import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_CUISINE_TYPE_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateCuisineTypeSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_CUISINE_TYPE_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateCuisineTypeSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.cuisineTypes.cuisineType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_CUISINE_TYPE_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateCuisineTypeSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_CUISINE_TYPE_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateCuisineTypeSimpleDetailsMutation
